import { ModalHeader } from '@chakra-ui/react';
import { useOverviewContext } from '@resistapp/client/contexts/use-overview-context/use-overview-context';
import { L2Targets } from '@resistapp/common/assays';
import { friendlyL2Target } from '@resistapp/common/friendly';
import { NoticeIcon } from '../icons/notice-icon';
import { IndexInfo } from '../modals/resistance-index/index-info';
import { oldTheme } from '../shared/old-styles';
import { InfoIconProps } from './info-icons-general';
import { MetricInfoIcon } from './metric-info-icon';

export function ResistanceIndexInfoIcon(props: InfoIconProps) {
  const { selectedAntibiotic } = useOverviewContext();

  const name = selectedAntibiotic
    ? `${friendlyL2Target(selectedAntibiotic as L2Targets)} Resistance Gene Index and Levels`
    : 'Antibiotic Resistance Gene Index and Levels';

  // Create the complete modal content, including the header
  const modalContent = (
    <>
      <ModalHeader style={{ marginLeft: '-20px' }}>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <NoticeIcon />
          <div style={{ paddingLeft: oldTheme.spacing.xs }}>{name}</div>
        </div>
      </ModalHeader>
      <IndexInfo />
    </>
  );

  return <MetricInfoIcon {...props} modalContent={modalContent} />;
}
